import React from "react";
import { Route } from "react-router-dom";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import {
  FunnelDetailsMobileScreenLazyComponent,
  FunnelTemplateSelectionLazyComponent,
  OnboardingQuestionsLazyComponent,
  OnboardingThankyouScreenLazyComponent,
} from "./Onboarding.lazy";

export const ONBOARDING_FLOW_KEY = "onboarding-questions";

export const ONBOARDING_ROUTE_KEYS = {
  ONBOARDING_THANKYOU_PAGE: "ONBOARDING_THANKYOU_PAGE",
  ONBOARDING_QUESTIONS: "ONBOARDING_QUESTIONS",
  FUNNEL_TEMPLATE_SELECTION: "FUNNEL_TEMPLATE_SELECTION",
  FUNNEL_TEMPLATE_DETAILS: "FUNNEL_TEMPLATE_DETAILS",
};

export const ONBOARDING_ROUTE_IDS = {
  [ONBOARDING_ROUTE_KEYS.ONBOARDING_THANKYOU_PAGE]: "/thankyou",
  [ONBOARDING_ROUTE_KEYS.ONBOARDING_QUESTIONS]: `/${ONBOARDING_FLOW_KEY}/:key`,
  [ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_SELECTION]: `/funnel-template-selection`,
  [ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_DETAILS]: `/funnel-details/:uid`,
};

export const ONBOARDING_PATHNAMES = {
  [ONBOARDING_ROUTE_KEYS.ONBOARDING_QUESTIONS]: (key) =>
    `/${ONBOARDING_FLOW_KEY}/${key}`,
  [ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_DETAILS]: ({ uid }) =>
    `/funnel-details/${uid}`,
};

export const ONBOARDING_CUSTOM_ROUTES = [
  <Route
    exact
    key={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.ONBOARDING_THANKYOU_PAGE]}
    path={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.ONBOARDING_THANKYOU_PAGE]}
    render={(props) => (
      <LazyLoadRoutes
        LazyElement={OnboardingThankyouScreenLazyComponent}
        props={props}
      />
    )}
    noLayout
  />,
  <Route
    exact
    key={`${ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.ONBOARDING_QUESTIONS]}`}
    path={`${ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.ONBOARDING_QUESTIONS]}`}
    render={(props) => (
      <LazyLoadRoutes
        LazyElement={OnboardingQuestionsLazyComponent}
        props={props}
      />
    )}
    noLayout
  />,
  <Route
    exact
    key={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_SELECTION]}
    path={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_SELECTION]}
    render={(props) => (
      <LazyLoadRoutes
        LazyElement={FunnelTemplateSelectionLazyComponent}
        props={props}
      />
    )}
    noLayout
  />,
  <Route
    exact
    key={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_DETAILS]}
    path={ONBOARDING_ROUTE_IDS[ONBOARDING_ROUTE_KEYS.FUNNEL_TEMPLATE_DETAILS]}
    render={(props) => (
      <LazyLoadRoutes
        LazyElement={FunnelDetailsMobileScreenLazyComponent}
        props={props}
      />
    )}
    noLayout
  />,
];
